import sunRise from 'images/rise-sunrise-logo.png';
import riseLogo from 'images/logo.svg';
import {Partner} from '../partners';
import styles from './CoBrandedLogo.module.css';

type Props = {partner: Partner};

export function CoBrandedLogo({partner}: Props) {
  return (
    <div className={styles.coBrand} role="img" aria-label={`${partner.name} × Rise`}>
      <img src={partner.logo} alt="" className={styles.partnerLogo} />
      <span aria-hidden="true" className={styles.divider}>
        ×
      </span>
      <img src={sunRise} alt="" className={styles.sunLogo} />
      <img src={riseLogo} alt="" className={styles.riseLogo} />
    </div>
  );
}
